<template>
  <div class="resource">
    <div class="row">
      <div class="col s12">
        <div class="header-wrapper">
          <div class="header">
          <button
            class="btn-floating btn-flat btn-back transparent"
            @click="$_goTo()"
          >
          <i class="material-icons-outlined">
            arrow_back
          </i>
        </button>
        <div class="section-title" v-html="currentItems.title"></div>
        <div class="search-bar z-depth-1">
            <form @submit.prevent="() => {}" autocomplete="off">
              <input
                type="text"
                v-model="search"
                autocomplete="off"
                name="searchBar"
                id="searchBar"
              />
            </form>
            <button style="position: absolute; right:0px; top: 0px;" v-if="search !== ''" @click="search = '' " class="btn-floating transparent waves-effect z-depth-0">
              <i class="material-icons grey-text text-darken-3"> cancel</i>
            </button>
          </div>


          </div>
        
      
      <!--     <div class="header">
            <div class="section-title">
              <button
                class="btn-floating btn-flat btn-back transparent"
                @click="$_goTo()"
              >
                <i class="material-icons-outlined">
                  arrow_back
                </i>
              </button>
              <div v-html="currentItems.title"></div>
            </div>
            <div class="input-filter">
              <i class="material-icons-outlined">search</i>
              <input type="text" class="white" v-model="search" />
            </div>
          </div> -->
        </div>
      </div>
      <div class="scrollable-content">
        <div class="col s12" v-for="(item, i) in currentItems.data" :key="i">
          <div class="card">
            <div class="card-content">
              <a
                class="card-title"
                v-if="item.link && item.link.url"
                :href="item.link.url"
                target="_blank"
                v-html="item.title + `<i class='material-icons'>link</i>`"
              ></a>
              <div v-else class="card-title" v-html="item.title"></div>
              <div
                class="source grey-text text-darken-4 grey lighten-5"
                style="padding:5px; margin: 12px 0px; font-style: italic"
                v-html="`Source: ` + item.source"
              ></div>
              <div class="description" v-html="item.description"></div>
              <youtube
                v-if="item.youtube"
                :player-vars="{}"
                :video-id="item.youtube"
                ref="youtube"
              ></youtube>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "resource",
  props: {},
  data() {
    return {
      search: "",
    };
  },
  computed: {
    ...mapState({
      resources: (state) => state.Helpers.resources,
    }),
    currentItems: {
      get() {
        const record = this.resources.find(
          (x) => x.id === parseInt(this.$route.params.id)
        );

        return {
          data: record
            ? record.acf.items.filter((x) =>
                x.title.toLowerCase().includes(this.search.toLowerCase())
              )
            : false,
          title: record.title.rendered,
        };
      },
    },
  },
  methods: {
    $_goTo() {
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="scss">
.resource {
  max-width: 768px;
  margin: auto;
  padding-bottom: 68px;
  .header-wrapper {
    position: relative;
    width: 100%;
    .header {
      .input-filter {
        position: relative;
        i {
          position: absolute;
          top: 8px;
          left: 11px;
        }
        input {
          border-radius: 24px;
          height: 36px;
          text-indent: 28px;
        }
      }
    }
  }
  .section-title {
    font-size: 28px;
    text-align: center;
    margin: 16px 0px 8px;
    @media screen and (max-width: 680px) {
      font-size: 22px;
      line-height: 1.2;
    }
  }
  .scrollable-content {
    display: inline-block;
    /*  max-height: calc(100vh - 280px);
    overflow: hidden;
    overflow-y: scroll; */
  }
  .card-title {
    font-size: 20px;
    line-height: 1.3;
  }

  .btn-back {
    position: absolute;
    left: 0;
    i {
      color: #000 !important;
    }

    // display: flex;
  }
}


 .search-bar {
    background: white;
    margin: 16px 12px 0px;
    width: 100%;
    border-radius: 6px;
    position: relative;
    @media screen and (min-width: 768px) {
     /*  max-width: calc(768px - 82px); */
   /*    transform: translateX(-35px); */
      margin-left: auto;
      margin-right: auto;
    }
    &::before {
      content: "search";
      font-family: "Material Icons";
      position: absolute;
      font-size: 20px;
      line-height: 38px;
      margin-left: 14px;
    }
    input[type="text"] {
      border: none !important;
      margin: 0px !important;
      box-shadow: none !important;
      padding: 0 12px 0 43px !important;
      width: calc(100% - 64px) !important;
      height: 40px !important;
      line-height: 40px !important;
      font-size: 14px !important;
    }
  }
</style>
<style lang="scss">
.resource {
  iframe {
    max-width: 100%;
    width: 100%;
  }
  .card {
    a {
      &.card-title {
        i {
          font-size: 18px;
          margin: 4px 0px 0 4px;
          transform: translateY(3px);
        }
      }
    }
  }
}
</style>
